














































import { Component, Mixins } from "vue-property-decorator";

// Mixins
import HasValidation from "@/mixins/HasValidation";

// Types
import { IClientAuthProviderMethods } from "@/models/providers/clientAuth";

@Component({
  components: {
    "client-auth-provider": () =>
      import("@/components/app/global/auth/clientAuth/clientAuthProvider.vue"),
    "client-auth-login-fields": () =>
      import(
        "@/components/app/global/auth/clientAuth/clientAuthLoginFields.vue"
      )
  }
})
export default class ClientLoginModal extends Mixins(HasValidation) {
  // Variables

  public isProcessing = false;

  // Methods

  public async validateBeforeSubmit(
    clientAuthMethods: IClientAuthProviderMethods
  ) {
    try {
      this.isProcessing = true;
      if (!(await this.validate())) {
        throw this.$t("_sentence.form_is_not_valid");
      }

      await clientAuthMethods.login();
      this.$emit("logged-in");
    } catch (error) {
      if (error === "cancelled") {
        return;
      }
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }
}
